import GoogleTagManagerHelper from '@tracking/gtm-helper';

export const clickTracking = (eventLabel: string, eventAction: string, eventName: string) => {
  GoogleTagManagerHelper.event('Click', eventAction, eventLabel, { section_reference: eventLabel }, eventName);
};
